import logoAlto from './assets/logo-alto.png';
import logoAvalanche from './assets/logo-avalanche.png';
import logoBobbie from './assets/logo-bobbie.png';
import logoCarta from './assets/logo-carta.png';
import logoGoterra from './assets/logo-goterra.png';
import logoGumroad from './assets/logo-gumroad.png';
import logoInside from './assets/logo-inside.png';
import logoKlarna from './assets/logo-klarna.png';
import logoMaven from './assets/logo-maven.png';
import logoPlaid from './assets/logo-plaid.png';
import logoRobinhood from './assets/logo-robinhood.png';
import logoSpacex from './assets/logo-spacex.png';

export const COMPANIES = [
  { company: 'Alto', logo: logoAlto },
  { company: 'Avalanche', logo: logoAvalanche },
  { company: 'Bobbie', logo: logoBobbie },
  { company: 'Carta', logo: logoCarta },
  { company: 'Goterra', logo: logoGoterra },
  { company: 'Gumroad', logo: logoGumroad },
  { company: 'Inside', logo: logoInside },
  { company: 'Klarna', logo: logoKlarna },
  { company: 'Maven', logo: logoMaven },
  { company: 'Plaid', logo: logoPlaid },
  { company: 'Robinhood', logo: logoRobinhood },
  { company: 'SpaceX', logo: logoSpacex },
];
